export default __webpack_public_path__ + "static/media/connect.1aa890f7.svg";